import { create } from 'zustand';

type UnsavedChangesSessionStoreState = {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (newValue: boolean) => void;
};

export const useUnsavedChangesSessionStore = create<UnsavedChangesSessionStoreState>(set => ({
  hasUnsavedChanges: false,
  setHasUnsavedChanges: newValue => set({ hasUnsavedChanges: newValue }),
}));
